import { useState, useEffect } from "react";
import WorkerServices from "../../services/Worker.services";

function useCountSegmentInTree(toDisplayData) {
    const [segmentCount, setsegmentCount] = useState(0);

    useEffect(() => {
        if (toDisplayData.length) {
            WorkerServices.countItems(toDisplayData).then((count) => {
                setsegmentCount(count);
            });
        } else {
            setsegmentCount(0);
        }
    }, [toDisplayData]);

    return segmentCount;
}

export default useCountSegmentInTree;
